module.exports = __webpack_public_path__ + "media/dobry_wzor/mail-polub-nas-bcg-834d3cae.png";